import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchPharmacyStores } from './api';
import type { PharmacyChannel, PharmacyStore } from './types';

/** The stores at the active branch and the channel → store map. Branch-scoped. */
export function usePharmacyStores() {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.pharmacy.stores(), branchVersion],
    queryFn: fetchPharmacyStores,
    staleTime: 60_000,
  });
}

/** The store a channel sells from, once loaded. */
export function useChannelStore(channel: PharmacyChannel): PharmacyStore | undefined {
  const { data } = usePharmacyStores();
  const id = data?.channels[channel];
  return id ? data?.stores.find((s) => s.id === id) : undefined;
}

/** True when the branch has more than one active store — single-store sites see no store UI at all. */
export function useHasMultipleStores(): boolean {
  const { data } = usePharmacyStores();
  return (data?.stores.filter((s) => s.active).length ?? 0) > 1;
}
